(function (globalScope, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) module.exports = api;
  if (globalScope) globalScope.CernirCustomStrapLiningData = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  const DATA = Object.freeze({
  "version": "demo-v1.0.0",
  "defaults": {
    "liningMaterial": "zermatt-leather",
    "liningColour": "golden"
  },
  "materials": [
    {
      "id": "zermatt-leather",
      "label": "Zermatt Leather",
      "paletteMaterialId": null,
      "helperText": "Choose Zermatt Leather as the lining material.",
      "disabled": false,
      "priceModifier": null,
      "colourInventory": [
        {
          "id": "golden",
          "label": "Golden",
          "helperText": "Choose Golden for Zermatt Leather.",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "beige",
          "label": "Beige",
          "helperText": "Choose Beige for Zermatt Leather.",
          "disabled": false,
          "priceModifier": null
        }
      ]
    },
    {
      "id": "calfskin-epsom",
      "label": "Calfskin (Epsom)",
      "paletteMaterialId": "epsom",
      "helperText": "Choose Calfskin (Epsom) as the lining material.",
      "disabled": false,
      "priceModifier": null,
      "colourInventory": [
        {
          "id": "golden-brown",
          "label": "Golden Brown",
          "helperText": "Choose Golden Brown for Calfskin (Epsom).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "navy",
          "label": "Navy",
          "helperText": "Choose Navy for Calfskin (Epsom).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "black",
          "label": "Black",
          "helperText": "Choose Black for Calfskin (Epsom).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "taupe",
          "label": "Taupe",
          "helperText": "Choose Taupe for Calfskin (Epsom).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "dark-navy",
          "label": "Dark Navy",
          "helperText": "Choose Dark Navy for Calfskin (Epsom).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "olive-green",
          "label": "Olive Green",
          "helperText": "Choose Olive Green for Calfskin (Epsom).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "tan",
          "label": "Tan",
          "helperText": "Choose Tan for Calfskin (Epsom).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "orange",
          "label": "Orange",
          "helperText": "Choose Orange for Calfskin (Epsom).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "pistachio-green",
          "label": "Pistachio Green",
          "helperText": "Choose Pistachio Green for Calfskin (Epsom).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "coral-red",
          "label": "Coral Red",
          "helperText": "Choose Coral Red for Calfskin (Epsom).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "grey",
          "label": "Grey",
          "helperText": "Choose Grey for Calfskin (Epsom).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "lemon-yellow",
          "label": "Lemon Yellow",
          "helperText": "Choose Lemon Yellow for Calfskin (Epsom).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "petrol-blue",
          "label": "Petrol Blue",
          "helperText": "Choose Petrol Blue for Calfskin (Epsom).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "camel",
          "label": "Camel",
          "helperText": "Choose Camel for Calfskin (Epsom).",
          "disabled": false,
          "priceModifier": null
        }
      ]
    },
    {
      "id": "goatskin-alran-chevre",
      "label": "Goatskin (Alran Chevre)",
      "paletteMaterialId": "alran-chevre",
      "helperText": "Choose Goatskin (Alran Chevre) as the lining material.",
      "disabled": false,
      "priceModifier": null,
      "colourInventory": [
        {
          "id": "black",
          "label": "Black",
          "helperText": "Choose Black for Goatskin (Alran Chevre).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "taupe",
          "label": "Taupe",
          "helperText": "Choose Taupe for Goatskin (Alran Chevre).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "navy-blue",
          "label": "Navy Blue",
          "helperText": "Choose Navy Blue for Goatskin (Alran Chevre).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "red",
          "label": "Red",
          "helperText": "Choose Red for Goatskin (Alran Chevre).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "golden-brown",
          "label": "Golden Brown",
          "helperText": "Choose Golden Brown for Goatskin (Alran Chevre).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "bordeaux",
          "label": "Bordeaux",
          "helperText": "Choose Bordeaux for Goatskin (Alran Chevre).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "burgundy",
          "label": "Burgundy",
          "helperText": "Choose Burgundy for Goatskin (Alran Chevre).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "grey",
          "label": "Grey",
          "helperText": "Choose Grey for Goatskin (Alran Chevre).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "white",
          "label": "White",
          "helperText": "Choose White for Goatskin (Alran Chevre).",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "light-grey",
          "label": "Light Grey",
          "helperText": "Choose Light Grey for Goatskin (Alran Chevre).",
          "disabled": false,
          "priceModifier": null
        }
      ]
    },
    {
      "id": "alligator-round-scales",
      "label": "Alligator Round Scales",
      "paletteMaterialId": null,
      "helperText": "Choose Alligator Round Scales as the lining material.",
      "disabled": false,
      "priceModifier": null,
      "colourInventory": [
        {
          "id": "black",
          "label": "Black",
          "helperText": "Choose Black for Alligator Round Scales.",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "ocean-blue",
          "label": "Ocean Blue",
          "helperText": "Choose Ocean Blue for Alligator Round Scales.",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "navy",
          "label": "Navy",
          "helperText": "Choose Navy for Alligator Round Scales.",
          "disabled": false,
          "priceModifier": null
        },
        {
          "id": "green",
          "label": "Green",
          "helperText": "Choose Green for Alligator Round Scales.",
          "disabled": false,
          "priceModifier": null
        }
      ]
    }
  ]
});

  const materialsById = new Map(DATA.materials.map((material) => [material.id, material]));

  function getMaterial(materialId) {
    return materialsById.get(materialId) || null;
  }

  function getColours(materialId) {
    return getMaterial(materialId)?.colourInventory || [];
  }

  function isMaterial(materialId) {
    const material = getMaterial(materialId);
    return Boolean(material && !material.disabled);
  }

  function isColourForMaterial(colourId, materialId) {
    return getColours(materialId).some((colour) => colour.id === colourId && !colour.disabled);
  }

  function transition(rawState, stateApi, field, value) {
    let next = stateApi.updateRawState(rawState, field, value);

    // A new lining material starts on its first colour (Zermatt: Golden), so the preview shows that leather at once.
    if (field === 'liningMaterial' && (value !== rawState.liningMaterial || !isColourForMaterial(next.liningColour, value))) {
      next = stateApi.updateRawState(next, 'liningColour', getColours(value).find((colour) => !colour.disabled)?.id || null);
    }

    if (field === 'liningColour' && !isColourForMaterial(value, next.liningMaterial)) {
      next = stateApi.updateRawState(next, 'liningColour', null);
    }

    return next;
  }

  return Object.freeze({ DATA, getMaterial, getColours, isMaterial, isColourForMaterial, transition });
});
